import React from "react";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { XCircle } from "react-feather";
import Template from "../../components/Template";
import AuthTemplate from "../../components/AuthTemplate";
import buscarLogo from "../../assets/images/buscar-logo-square.png";
import buscarLogoCompleto from "../../assets/images/buscar-logo-light-2.png";
import "./styles.scss";

const NotFound = () => {
  if (localStorage.getItem("access_token")) {
    return <Template component={AuthenticatedError} />;
  } else {
    return <AuthTemplate component={UnauthenticatedError} />;
  }
};

const AuthenticatedError = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <h1>{formatMessage({ id: "nao-encontrado" })}</h1>

      <div className="content-box not-found-container authenticated">
        <div className="tile is-ancestor">
          <div className="tile is-vertical logo-container">
            <img src={buscarLogo} alt="logo BusCAR" className="logo" />
          </div>
          <div className="tile is-vertical not-found-message">
            <p>{formatMessage({ id: "nao-encontrado-mensagem" })}</p>
            <p>
              {formatMessage({ id: "tente-voltar" })}
              <Link to="/">{formatMessage({ id: "pagina-inicial" })}</Link>.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

const UnauthenticatedError = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <div className="logo has-title">
        <img alt="logo BusCAR" src={buscarLogoCompleto} />
        <div className="auth-title">
          {formatMessage({ id: "nao-encontrado" })}
        </div>
      </div>

      <div className="not-found-container unauthenticated">
        <div className="tile is-ancestor">
          <div className="tile is-vertical logo-container">
            <img src={buscarLogo} alt="logo BusCAR" className="logo" />
          </div>
          <div className="not-found-message">
            <XCircle className="error-icon" size="32px" />
            <p>{formatMessage({ id: "nao-encontrado-mensagem" })}</p>
            <p className="links">
              {formatMessage({ id: "tente-voltar" })}
              <Link to="/login">{formatMessage({ id: "pagina-login" })}</Link>.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
